import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "typeof",
})
export class TypeofPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return typeof value;
  }
}
